// Port of api/fuel/app/classes/filter/search/games/rules/query/play_outcome.php
import Rule from 'offline/filter/core/search/rule'

export default Rule.create({
	name: 'play_outcome',
	match: function(rule, config, filter, data, query) {
		query.where('p.user_id', 'in', data.users)

		if (rule.logic.value === 'win') {
			query.where('p.play_result', '=', '1')
			query.where('p.play_won', '=', '1')
		} else if (rule.logic.value === 'loss') {
			query.where('p.play_result', '=', '1')
			query.where('p.play_won', '=', '0')
		} else if (rule.logic.value === 'untracked') {
			query.where('p.play_result', '=', '0')
		}
	}
})
